export default {
  uz: {
    seo: {
      home: { title: 'Bosh sahifa - Tech College', description: "Tech College - Zamonaviy ta'lim va kuchli mutaxassislar tayyorlaydigan yetakchi o'quv muassasasi" },
      news: { title: 'Yangiliklar - Tech College', description: "Kollejimizdagi so'nggi yangiliklar va tadbirlar" },
      sections: { title: "Yo'nalishlar - Tech College", description: "Tech College da mavjud ta'lim yo'nalishlari va guruhlar" },
      teachers: { title: "O'qituvchilar - Tech College", description: "Professional va tajribali o'qituvchilarimiz bilan tanishing" },
      contact: { title: 'Aloqa - Tech College', description: "Biz bilan bog'laning va savollaringizga javob oling" },
      notFound: { title: '404 - Sahifa topilmadi', description: 'Kechirasiz, bu sahifa mavjud emas' },
      defaultDescription: "Tech College - Zamonaviy ta'lim markazi"
    },
    common: {
      loading: 'Yuklanmoqda...',
      retry: 'Qayta urinish',
      save: 'Saqlash',
      cancel: 'Bekor qilish',
      add: "Qo'shish",
      logout: 'Chiqish',
      dashboard: 'Dashboard',
      unknown: "Noma'lum"
    },
    nav: {
      home: 'Bosh sahifa',
      sections: "Yo'nalishlar",
      teachers: "O'qituvchilar",
      news: 'Yangiliklar',
      contact: "Aloqada bo'lish",
      language: 'Til'
    },
    language: {
      uz: "O'zbek",
      ru: 'Русский',
      en: 'English'
    },
    hero: {
      district: 'Payariq tuman',
      college: '2-son texnikumi',
      subtitle: "Zamonaviy ta'lim va kuchli mutaxassislar tayyorlash markazi",
      sections: "Yo'nalishlar",
      contact: "Bog'lanish",
      students: 'Talabalar',
      teachers: "O'qituvchilar"
    },
    footer: {
      about: "Zamonaviy ta'lim va kuchli mutaxassislar tayyorlashga qaratilgan texnikumimiz o'quvchilar uchun eng yaxshi sharoitlarni yaratadi.",
      sections: "Bo'limlar",
      contact: 'Aloqa',
      address: "Qumchuq MFY, Furqat ko'cha 4-uy",
      rights: "Barcha huquqlar himoyalangan.",
      privacy: 'Maxfiylik siyosati',
      terms: 'Foydalanish shartlari'
    },
    map: {
      title: 'Bizning Manzil',
      subtitle: "Biz bilan bog'lanish va tashrif buyurish uchun",
      mapTitle: 'Kollej Manzili',
      phone: 'Telefon',
      phoneHours: 'Har kuni 9:00 - 18:00',
      email: 'Email',
      emailHelp: '24/7 javob beramiz',
      workTime: 'Ish vaqti',
      workDays: 'Dushanba - Shanba'
    },
    news: {
      badge: "So'nggi yangiliklar",
      title: 'Yangiliklar',
      subtitle: "Texnikumimizdagi so'nggi yangiliklar va tadbirlar haqida ma'lumot",
      searchPlaceholder: 'Yangilik qidirish...',
      sortNewest: 'Eng yangi',
      sortOldest: 'Eng eski',
      errorTitle: 'Xatolik yuz berdi',
      allNews: 'Barcha yangiliklar',
      foundCount: '{count} ta yangilik topildi',
      readMore: 'Batafsil',
      emptyTitle: 'Hech narsa topilmadi',
      emptyDesc: "Qidiruv so'rovingizni o'zgartiring",
      loadMore: "Ko'proq yuklash",
      close: 'Yopish',
      today: 'Bugun',
      yesterday: 'Kecha',
      daysAgo: '{count} kun oldin',
      unknownError: "Noma'lum xatolik"
    },
    sections: {
      badge: "Ta'lim yo'nalishlari",
      title: "Yo'nalishlar",
      subtitle: "O'zingizga mos kasbiy yo'nalishni tanlang va professional bo'ling",
      statsPrograms: "Yo'nalishlar",
      statsGroups: "Guruhlar",
      statsEmployment: "Ish bilan ta'minlash",
      allPrograms: "Barcha yo'nalishlar",
      choose: "O'zingizga mos yo'nalishni tanlang",
      groupCount: "{count} ta guruh",
      empty: "Hozircha yo'nalishlar kiritilmagan.",
      loadError: "Yo'nalishlarni yuklashda xatolik"
    },
    notFound: {
      title: 'Sahifa Topilmadi',
      description: "Kechirasiz, siz qidirayotgan sahifa mavjud emas yoki ko'chirilgan. Bosh sahifaga qaytib, kerakli ma'lumotni toping.",
      home: 'Bosh sahifaga qaytish',
      back: 'Orqaga qaytish',
      quickLinks: 'Tez havolalar:',
      support: "Agar muammo davom etsa, biz bilan bog'laning:"
    },
    adminLogin: {
      title: 'Admin Panel',
      subtitle: 'Tech College CMS',
      username: 'Username',
      password: 'Parol',
      login: 'Kirish',
      back: 'Bosh sahifaga qaytish',
      enterCredentials: 'Username va password kiriting!',
      tokenMissing: 'Token topilmadi!',
      genericError: 'Xatolik yuz berdi!'
    },
    adminSections: {
      title: "Yo'nalishlar boshqaruvi",
      subtitle: "Admin paneldan yo'nalish va guruhlarni kiriting",
      formTitleCreate: "Yangi yo'nalish",
      formTitleEdit: "Yo'nalishni tahrirlash",
      sectionName: "Yo'nalish nomi",
      sectionNamePlaceholder: 'Masalan: Dasturlash',
      groups: 'Guruhlar',
      groupsPlaceholder: "Har qatorda bitta guruh yozing\n101-guruh\n102-guruh",
      groupsHint: "Har yangi qator alohida guruh bo'ladi.",
      saving: 'Saqlanmoqda...',
      update: 'Yangilash',
      listTitle: "Yo'nalishlar ro'yxati",
      noData: "Hozircha yo'nalish kiritilmagan.",
      edit: 'Tahrirlash',
      delete: "O'chirish",
      groupsCount: 'ta guruh',
      fillError: "Yo'nalish nomi va kamida bitta guruh kiriting",
      createSuccess: "Yo'nalish qo'shildi",
      updateSuccess: "Yo'nalish yangilandi",
      loadError: "Yo'nalishlarni yuklashda xatolik",
      saveError: 'Saqlashda xatolik',
      deleteError: "O'chirishda xatolik",
      deleteConfirm: "Rostdan ham o'chirmoqchimisiz?"
    },
    home: {
      aboutBadge: 'Biz haqimizda',
      aboutTitle: "Kasbiy Ta'lim Agentligi",
      aboutDesc: "Kasbiy ta'lim va kasbga o'qitishda boshqaruv tizimini takomillashtirish orqali yagona yondashuv asosida kasbga o'qitish, ilg'or xorijiy tajribalarni samarali joriy etish va xalqaro standartlarga mos bo'lgan yuqori malakali mutaxasislarini tayorlash",
      feature1Title: "Sifatli ta'lim",
      feature1Desc: "Professional o'qituvchilar",
      feature2Title: 'Zamonaviy uskunalar',
      feature2Desc: 'Innovatsion laboratoriyalar',
      aboutAction: "Yo'nalishlar bilan tanishing",
      newsAll: 'Barcha yangiliklar',
      sectionsLoading: "Yo'nalishlar yuklanmoqda...",
      groupsEmpty: 'Guruhlar hali kiritilmagan',
      sectionsAll: "Barcha yo'nalishlar",
      ctaTitle: "Bizga qo'shiling!",
      ctaDesc: "Kelajagingizni bugun quring. Payariq tumani 2-sonli texnikumi bilan professional ta'lim oling va muvaffaqiyatli karyera boshlang.",
      ctaContact: "Hoziroq bog'laning",
      ctaSections: "Yo'nalishlarni ko'ring",
      seo: {
        title: 'Payariq 2-son texnikum - Samarqanddagi zamonaviy kasb-hunar maktabi',
        p1: "Payariq 2-son texnikum Samarqand viloyati Payariq tumanida joylashgan yetakchi kasb-hunar maktabidir.",
        h2a: "Payariq kasb-hunar maktabida professional ta'lim",
        p2: "Texnikumda avtomobillarni ta'mirlash, tikuvchilik va traktorchi-mashinist yo'nalishlari bo'yicha ta'lim beriladi.",
        h2b: "Payariq texnikum yo'nalishlari",
        li1: "Avtomobillarni ta'mirlash",
        li2: 'Tikuvchilik',
        li3: 'Traktorchi-mashinist',
        p3: "Payariq 2-son texnikumda o'qish — bu ishonchli kelajak va sifatli ta'lim demakdir."
      }
    },
    teachersPreview: {
      badge: 'Bizning rahbariyat',
      title: 'Texnikum rahbariyati',
      leadership: 'Rahbariyat',
      emptyTitle: 'Rahbariyat topilmadi',
      emptyDesc: "Backend'da \"Rahbariyat\" department'i bilan o'qituvchi qo'shing",
      viewAll: "Barcha o'qituvchilarni ko'rish",
      experience: 'Yillik tajriba',
      success: 'Muvaffaqiyat',
      loadError: "Ma'lumotlarni yuklashda xatolik"
    },
    teachers: {
      badge: 'Bizning jamoa',
      title: "O'qituvchilar",
      searchPlaceholder: "O'qituvchi qidirish...",
      errorTitle: 'Xatolik yuz berdi',
      leadership: 'Rahbariyat',
      leadershipCount: '{count} ta rahbar',
      subjectTeachers: "Fan o'qituvchilari",
      teacherCount: "{count} ta o'qituvchi",
      emptyTitle: 'Hech narsa topilmadi',
      emptyDesc: "Qidiruv so'rovingizni o'zgartiring",
      filterAll: 'Barchasi',
      filterLeadership: 'Rahbariyat',
      filterSubjects: "Fan o'qituvchilari",
      unknownError: 'Xatolik yuz berdi'
    },
    contact: {
      badge: "Biz bilan bog'laning",
      title: 'Aloqa',
      subtitle: 'Savollaringiz bormi? Biz har doim yordam berishga tayyormiz!',
      sendTitle: 'Xabar yuboring',
      sendDesc: "Formani to'ldiring, tez orada siz bilan bog'lanamiz",
      name: 'Ismingiz',
      namePlaceholder: 'Ismingizni kiriting',
      phone: 'Telefon raqam',
      subject: 'Mavzu',
      select: 'Tanlang',
      optAdmission: 'Qabul haqida',
      optStudy: "O'quv jarayoni",
      optPrograms: "Yo'nalishlar",
      optOther: 'Boshqa savol',
      message: 'Xabar',
      messagePlaceholder: 'Xabaringizni yozing...',
      send: 'Yuborish',
      sending: 'Yuborilmoqda...',
      infoTitle: "Aloqa ma'lumotlari",
      address: 'Manzil',
      phoneHours: 'Dushanba - Shanba: 9:00 - 16:00',
      emailHours: '24/7 javob beramiz',
      workTime: 'Ish vaqti',
      workMonFri: 'Dushanba - Juma',
      workSat: 'Shanba',
      workSun: 'Yakshanba',
      off: 'Dam olish',
      success: "Xabaringiz muvaffaqiyatli yuborildi! Tez orada siz bilan bog'lanamiz.",
      error: "Xatolik yuz berdi. Iltimos qaytadan urinib ko'ring yoki telefon orqali bog'laning."
    },
    adminDashboard: {
      goSite: "Saytga o'tish",
      addSection: "Yo'nalish qo'shish",
      teachersTab: "O'qituvchilar ({count})",
      newsTab: 'Yangiliklar ({count})',
      edit: 'Tahrirlash',
      addNew: "Yangi qo'shish",
      image: 'Rasm',
      fullName: 'Ism Familiya',
      fullNamePlaceholder: 'Alisher Navoiy',
      subject: 'Fan / Lavozim',
      subjectPlaceholder: 'Matematika',
      department: "Bo'lim",
      select: 'Tanlang',
      depLeadership: 'Rahbariyat',
      depApplied: 'Amaliy fanlar',
      depLanguages: 'Tillar',
      list: "Ro'yxat",
      newsTitle: 'Sarlavha',
      newsTitlePlaceholder: 'Yangilik sarlavhasi',
      text: 'Matn',
      newsTextPlaceholder: 'Yangilik matni...',
      date: 'Sana',
      loadTeachersError: "O'qituvchilarni yuklashda xatolik!",
      loadNewsError: 'Yangiliklarni yuklashda xatolik!',
      updateSuccess: 'Muvaffaqiyatli yangilandi!',
      createSuccess: "Muvaffaqiyatli qo'shildi!",
      submitError: 'Xatolik yuz berdi!',
      deleteConfirm: "Rostdan ham o'chirmoqchimisiz?",
      deleteSuccess: "Muvaffaqiyatli o'chirildi!",
      deleteError: "O'chirishda xatolik!"
    }
  },
  ru: {
    seo: {
      home: { title: 'Главная - Tech College', description: 'Tech College — современное учебное заведение с сильной подготовкой специалистов' },
      news: { title: 'Новости - Tech College', description: 'Последние новости и события колледжа' },
      sections: { title: 'Направления - Tech College', description: 'Учебные направления и группы в Tech College' },
      teachers: { title: 'Преподаватели - Tech College', description: 'Познакомьтесь с нашими профессиональными преподавателями' },
      contact: { title: 'Контакты - Tech College', description: 'Свяжитесь с нами и получите ответы на вопросы' },
      notFound: { title: '404 - Страница не найдена', description: 'Извините, эта страница не существует' },
      defaultDescription: 'Tech College — современный образовательный центр'
    },
    common: {
      loading: 'Загрузка...',
      retry: 'Повторить',
      save: 'Сохранить',
      cancel: 'Отмена',
      add: 'Добавить',
      logout: 'Выход',
      dashboard: 'Панель',
      unknown: 'Неизвестно'
    },
    nav: {
      home: 'Главная',
      sections: 'Направления',
      teachers: 'Преподаватели',
      news: 'Новости',
      contact: 'Контакты',
      language: 'Язык'
    },
    language: {
      uz: 'O‘zbek',
      ru: 'Русский',
      en: 'English'
    },
    hero: {
      district: 'Пайарыкский район',
      college: '2-й техникум',
      subtitle: 'Центр современного образования и подготовки сильных специалистов',
      sections: 'Направления',
      contact: 'Связаться',
      students: 'Студенты',
      teachers: 'Преподаватели'
    },
    footer: {
      about: 'Наш техникум создает лучшие условия для студентов и готовит сильных специалистов.',
      sections: 'Разделы',
      contact: 'Контакты',
      address: 'МФЙ Кумчук, улица Фуркат, дом 4',
      rights: 'Все права защищены.',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия использования'
    },
    map: {
      title: 'Наш адрес',
      subtitle: 'Для связи и посещения',
      mapTitle: 'Адрес колледжа',
      phone: 'Телефон',
      phoneHours: 'Ежедневно 9:00 - 18:00',
      email: 'Email',
      emailHelp: 'Отвечаем 24/7',
      workTime: 'Время работы',
      workDays: 'Понедельник - Суббота'
    },
    news: {
      badge: 'Последние новости',
      title: 'Новости',
      subtitle: 'Последние новости и события нашего техникума',
      searchPlaceholder: 'Поиск новости...',
      sortNewest: 'Сначала новые',
      sortOldest: 'Сначала старые',
      errorTitle: 'Произошла ошибка',
      allNews: 'Все новости',
      foundCount: 'Найдено новостей: {count}',
      readMore: 'Подробнее',
      emptyTitle: 'Ничего не найдено',
      emptyDesc: 'Измените поисковый запрос',
      loadMore: 'Загрузить еще',
      close: 'Закрыть',
      today: 'Сегодня',
      yesterday: 'Вчера',
      daysAgo: '{count} дн. назад',
      unknownError: 'Неизвестная ошибка'
    },
    sections: {
      badge: 'Образовательные направления',
      title: 'Направления',
      subtitle: 'Выберите подходящее направление и станьте профессионалом',
      statsPrograms: 'Направления',
      statsGroups: 'Группы',
      statsEmployment: 'Трудоустройство',
      allPrograms: 'Все направления',
      choose: 'Выберите подходящее направление',
      groupCount: 'Групп: {count}',
      empty: 'Пока направления не добавлены.',
      loadError: 'Ошибка загрузки направлений'
    },
    notFound: {
      title: 'Страница не найдена',
      description: 'Страница, которую вы ищете, не существует или была перемещена. Вернитесь на главную.',
      home: 'На главную',
      back: 'Назад',
      quickLinks: 'Быстрые ссылки:',
      support: 'Если проблема повторяется, свяжитесь с нами:'
    },
    adminLogin: {
      title: 'Админ панель',
      subtitle: 'Tech College CMS',
      username: 'Логин',
      password: 'Пароль',
      login: 'Войти',
      back: 'Вернуться на главную',
      enterCredentials: 'Введите логин и пароль!',
      tokenMissing: 'Токен не найден!',
      genericError: 'Произошла ошибка!'
    },
    adminSections: {
      title: 'Управление направлениями',
      subtitle: 'Добавляйте направления и группы из админ-панели',
      formTitleCreate: 'Новое направление',
      formTitleEdit: 'Редактировать направление',
      sectionName: 'Название направления',
      sectionNamePlaceholder: 'Например: Программирование',
      groups: 'Группы',
      groupsPlaceholder: 'Каждая строка — отдельная группа\n101-группа\n102-группа',
      groupsHint: 'Каждая новая строка будет отдельной группой.',
      saving: 'Сохранение...',
      update: 'Обновить',
      listTitle: 'Список направлений',
      noData: 'Пока нет добавленных направлений.',
      edit: 'Редактировать',
      delete: 'Удалить',
      groupsCount: 'групп',
      fillError: 'Введите название и минимум одну группу',
      createSuccess: 'Направление добавлено',
      updateSuccess: 'Направление обновлено',
      loadError: 'Ошибка загрузки направлений',
      saveError: 'Ошибка при сохранении',
      deleteError: 'Ошибка при удалении',
      deleteConfirm: 'Вы действительно хотите удалить?'
    },
    home: {
      aboutBadge: 'О нас',
      aboutTitle: 'Агентство профессионального образования',
      aboutDesc: 'Совершенствование управления профобразованием, внедрение передового зарубежного опыта и подготовка высококвалифицированных специалистов по международным стандартам.',
      feature1Title: 'Качественное образование',
      feature1Desc: 'Профессиональные преподаватели',
      feature2Title: 'Современное оборудование',
      feature2Desc: 'Инновационные лаборатории',
      aboutAction: 'Ознакомиться с направлениями',
      newsAll: 'Все новости',
      sectionsLoading: 'Загрузка направлений...',
      groupsEmpty: 'Группы пока не добавлены',
      sectionsAll: 'Все направления',
      ctaTitle: 'Присоединяйтесь к нам!',
      ctaDesc: 'Стройте будущее уже сегодня. Получите профессиональное образование в техникуме №2 Пайарыкского района.',
      ctaContact: 'Связаться сейчас',
      ctaSections: 'Смотреть направления',
      seo: {
        title: 'Техникум №2 Пайарык - современная профшкола Самарканда',
        p1: 'Техникум №2 Пайарык — ведущее учреждение профобразования в Самаркандской области.',
        h2a: 'Профессиональное образование в Пайарыкской профшколе',
        p2: 'Обучение по направлениям: ремонт автомобилей, швейное дело и тракторист-машинист.',
        h2b: 'Направления техникума Пайарык',
        li1: 'Ремонт автомобилей',
        li2: 'Швейное дело',
        li3: 'Тракторист-машинист',
        p3: 'Обучение в техникуме №2 Пайарык — это надежное будущее и качественное образование.'
      }
    },
    teachersPreview: {
      badge: 'Наше руководство',
      title: 'Руководство техникума',
      leadership: 'Руководство',
      emptyTitle: 'Руководство не найдено',
      emptyDesc: 'Добавьте преподавателя с отделом \"Руководство\" в backend',
      viewAll: 'Смотреть всех преподавателей',
      experience: 'Лет опыта',
      success: 'Успех',
      loadError: 'Ошибка загрузки данных'
    },
    teachers: {
      badge: 'Наша команда',
      title: 'Преподаватели',
      searchPlaceholder: 'Поиск преподавателя...',
      errorTitle: 'Произошла ошибка',
      leadership: 'Руководство',
      leadershipCount: 'Руководителей: {count}',
      subjectTeachers: 'Предметные преподаватели',
      teacherCount: 'Преподавателей: {count}',
      emptyTitle: 'Ничего не найдено',
      emptyDesc: 'Измените поисковый запрос',
      filterAll: 'Все',
      filterLeadership: 'Руководство',
      filterSubjects: 'Предметные преподаватели',
      unknownError: 'Произошла ошибка'
    },
    contact: {
      badge: 'Свяжитесь с нами',
      title: 'Контакты',
      subtitle: 'Есть вопросы? Мы всегда готовы помочь!',
      sendTitle: 'Отправить сообщение',
      sendDesc: 'Заполните форму, и мы скоро свяжемся с вами',
      name: 'Ваше имя',
      namePlaceholder: 'Введите имя',
      phone: 'Телефон',
      subject: 'Тема',
      select: 'Выберите',
      optAdmission: 'О приеме',
      optStudy: 'Учебный процесс',
      optPrograms: 'Направления',
      optOther: 'Другой вопрос',
      message: 'Сообщение',
      messagePlaceholder: 'Напишите сообщение...',
      send: 'Отправить',
      sending: 'Отправка...',
      infoTitle: 'Контактная информация',
      address: 'Адрес',
      phoneHours: 'Понедельник - Суббота: 9:00 - 16:00',
      emailHours: 'Отвечаем 24/7',
      workTime: 'Время работы',
      workMonFri: 'Понедельник - Пятница',
      workSat: 'Суббота',
      workSun: 'Воскресенье',
      off: 'Выходной',
      success: 'Ваше сообщение успешно отправлено! Мы скоро свяжемся с вами.',
      error: 'Произошла ошибка. Попробуйте снова или свяжитесь с нами по телефону.'
    },
    adminDashboard: {
      goSite: 'Перейти на сайт',
      addSection: 'Добавить направление',
      teachersTab: 'Преподаватели ({count})',
      newsTab: 'Новости ({count})',
      edit: 'Редактировать',
      addNew: 'Добавить новое',
      image: 'Изображение',
      fullName: 'ФИО',
      fullNamePlaceholder: 'Алишер Навои',
      subject: 'Предмет / Должность',
      subjectPlaceholder: 'Математика',
      department: 'Отдел',
      select: 'Выберите',
      depLeadership: 'Руководство',
      depApplied: 'Прикладные науки',
      depLanguages: 'Языки',
      list: 'Список',
      newsTitle: 'Заголовок',
      newsTitlePlaceholder: 'Заголовок новости',
      text: 'Текст',
      newsTextPlaceholder: 'Текст новости...',
      date: 'Дата',
      loadTeachersError: 'Ошибка загрузки преподавателей!',
      loadNewsError: 'Ошибка загрузки новостей!',
      updateSuccess: 'Успешно обновлено!',
      createSuccess: 'Успешно добавлено!',
      submitError: 'Произошла ошибка!',
      deleteConfirm: 'Вы действительно хотите удалить?',
      deleteSuccess: 'Успешно удалено!',
      deleteError: 'Ошибка удаления!'
    }
  },
  en: {
    seo: {
      home: { title: 'Home - Tech College', description: 'Tech College is a modern education center preparing strong specialists' },
      news: { title: 'News - Tech College', description: 'Latest college news and events' },
      sections: { title: 'Programs - Tech College', description: 'Education programs and groups at Tech College' },
      teachers: { title: 'Teachers - Tech College', description: 'Meet our professional and experienced teachers' },
      contact: { title: 'Contact - Tech College', description: 'Contact us and get answers to your questions' },
      notFound: { title: '404 - Page Not Found', description: 'Sorry, this page does not exist' },
      defaultDescription: 'Tech College - Modern Education Center'
    },
    common: {
      loading: 'Loading...',
      retry: 'Retry',
      save: 'Save',
      cancel: 'Cancel',
      add: 'Add',
      logout: 'Logout',
      dashboard: 'Dashboard',
      unknown: 'Unknown'
    },
    nav: {
      home: 'Home',
      sections: 'Programs',
      teachers: 'Teachers',
      news: 'News',
      contact: 'Contact',
      language: 'Language'
    },
    language: {
      uz: 'Uzbek',
      ru: 'Russian',
      en: 'English'
    },
    hero: {
      district: 'Payariq District',
      college: 'Technical College No.2',
      subtitle: 'A center for modern education and strong specialist training',
      sections: 'Programs',
      contact: 'Contact',
      students: 'Students',
      teachers: 'Teachers'
    },
    footer: {
      about: 'Our technical college creates the best conditions for students and trains strong specialists.',
      sections: 'Sections',
      contact: 'Contact',
      address: 'Qumchuq MFY, Furqat street, house 4',
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use'
    },
    map: {
      title: 'Our Location',
      subtitle: 'For contact and visit',
      mapTitle: 'College Location',
      phone: 'Phone',
      phoneHours: 'Daily 9:00 - 18:00',
      email: 'Email',
      emailHelp: 'We reply 24/7',
      workTime: 'Working hours',
      workDays: 'Monday - Saturday'
    },
    news: {
      badge: 'Latest news',
      title: 'News',
      subtitle: 'Latest updates and events from our technical college',
      searchPlaceholder: 'Search news...',
      sortNewest: 'Newest',
      sortOldest: 'Oldest',
      errorTitle: 'An error occurred',
      allNews: 'All news',
      foundCount: '{count} news found',
      readMore: 'Read more',
      emptyTitle: 'Nothing found',
      emptyDesc: 'Try a different search query',
      loadMore: 'Load more',
      close: 'Close',
      today: 'Today',
      yesterday: 'Yesterday',
      daysAgo: '{count} days ago',
      unknownError: 'Unknown error'
    },
    sections: {
      badge: 'Education programs',
      title: 'Programs',
      subtitle: 'Choose the right program and become a professional',
      statsPrograms: 'Programs',
      statsGroups: 'Groups',
      statsEmployment: 'Employment',
      allPrograms: 'All programs',
      choose: 'Choose the right program for you',
      groupCount: '{count} groups',
      empty: 'No programs have been added yet.',
      loadError: 'Failed to load programs'
    },
    notFound: {
      title: 'Page Not Found',
      description: 'The page you are looking for does not exist or was moved. Please return to the home page.',
      home: 'Back to home',
      back: 'Go back',
      quickLinks: 'Quick links:',
      support: 'If the issue persists, contact us:'
    },
    adminLogin: {
      title: 'Admin Panel',
      subtitle: 'Tech College CMS',
      username: 'Username',
      password: 'Password',
      login: 'Login',
      back: 'Back to home',
      enterCredentials: 'Enter username and password!',
      tokenMissing: 'Token not found!',
      genericError: 'Something went wrong!'
    },
    adminSections: {
      title: 'Programs Management',
      subtitle: 'Add programs and groups from admin panel',
      formTitleCreate: 'New program',
      formTitleEdit: 'Edit program',
      sectionName: 'Program name',
      sectionNamePlaceholder: 'For example: Programming',
      groups: 'Groups',
      groupsPlaceholder: 'Write one group per line\n101-group\n102-group',
      groupsHint: 'Each new line becomes a separate group.',
      saving: 'Saving...',
      update: 'Update',
      listTitle: 'Programs list',
      noData: 'No programs added yet.',
      edit: 'Edit',
      delete: 'Delete',
      groupsCount: 'groups',
      fillError: 'Enter a program name and at least one group',
      createSuccess: 'Program added',
      updateSuccess: 'Program updated',
      loadError: 'Failed to load programs',
      saveError: 'Failed to save',
      deleteError: 'Failed to delete',
      deleteConfirm: 'Are you sure you want to delete?'
    },
    home: {
      aboutBadge: 'About us',
      aboutTitle: 'Agency of Vocational Education',
      aboutDesc: 'Improving vocational education management, applying international best practices, and training highly qualified specialists based on global standards.',
      feature1Title: 'Quality education',
      feature1Desc: 'Professional teachers',
      feature2Title: 'Modern equipment',
      feature2Desc: 'Innovative laboratories',
      aboutAction: 'Explore programs',
      newsAll: 'All news',
      sectionsLoading: 'Loading programs...',
      groupsEmpty: 'No groups added yet',
      sectionsAll: 'All programs',
      ctaTitle: 'Join us!',
      ctaDesc: 'Build your future today. Get professional education with Technical College No.2 of Payariq district.',
      ctaContact: 'Contact now',
      ctaSections: 'View programs',
      seo: {
        title: 'Payariq Technical College No.2 - modern vocational school',
        p1: 'Payariq Technical College No.2 is a leading vocational school in Samarkand region.',
        h2a: 'Professional education in Payariq vocational school',
        p2: 'Training is provided in auto repair, tailoring, and tractor driver programs.',
        h2b: 'Payariq college programs',
        li1: 'Auto repair',
        li2: 'Tailoring',
        li3: 'Tractor driver',
        p3: 'Studying at Payariq Technical College No.2 means a reliable future and quality education.'
      }
    },
    teachersPreview: {
      badge: 'Our leadership',
      title: 'College leadership',
      leadership: 'Leadership',
      emptyTitle: 'Leadership not found',
      emptyDesc: 'Add a teacher with \"Leadership\" department in backend',
      viewAll: 'View all teachers',
      experience: 'Years of experience',
      success: 'Success',
      loadError: 'Failed to load data'
    },
    teachers: {
      badge: 'Our team',
      title: 'Teachers',
      searchPlaceholder: 'Search teacher...',
      errorTitle: 'An error occurred',
      leadership: 'Leadership',
      leadershipCount: '{count} leaders',
      subjectTeachers: 'Subject teachers',
      teacherCount: '{count} teachers',
      emptyTitle: 'Nothing found',
      emptyDesc: 'Try a different search query',
      filterAll: 'All',
      filterLeadership: 'Leadership',
      filterSubjects: 'Subject teachers',
      unknownError: 'Something went wrong'
    },
    contact: {
      badge: 'Contact us',
      title: 'Contact',
      subtitle: 'Have questions? We are always ready to help!',
      sendTitle: 'Send message',
      sendDesc: 'Fill the form and we will contact you soon',
      name: 'Your name',
      namePlaceholder: 'Enter your name',
      phone: 'Phone number',
      subject: 'Subject',
      select: 'Select',
      optAdmission: 'About admission',
      optStudy: 'Study process',
      optPrograms: 'Programs',
      optOther: 'Other question',
      message: 'Message',
      messagePlaceholder: 'Write your message...',
      send: 'Send',
      sending: 'Sending...',
      infoTitle: 'Contact information',
      address: 'Address',
      phoneHours: 'Monday - Saturday: 9:00 - 16:00',
      emailHours: 'We reply 24/7',
      workTime: 'Working hours',
      workMonFri: 'Monday - Friday',
      workSat: 'Saturday',
      workSun: 'Sunday',
      off: 'Day off',
      success: 'Your message has been sent successfully! We will contact you soon.',
      error: 'Something went wrong. Please try again or contact us by phone.'
    },
    adminDashboard: {
      goSite: 'Go to site',
      addSection: 'Add program',
      teachersTab: 'Teachers ({count})',
      newsTab: 'News ({count})',
      edit: 'Edit',
      addNew: 'Add new',
      image: 'Image',
      fullName: 'Full name',
      fullNamePlaceholder: 'Alisher Navoiy',
      subject: 'Subject / Position',
      subjectPlaceholder: 'Mathematics',
      department: 'Department',
      select: 'Select',
      depLeadership: 'Leadership',
      depApplied: 'Applied sciences',
      depLanguages: 'Languages',
      list: 'List',
      newsTitle: 'Title',
      newsTitlePlaceholder: 'News title',
      text: 'Text',
      newsTextPlaceholder: 'News text...',
      date: 'Date',
      loadTeachersError: 'Failed to load teachers!',
      loadNewsError: 'Failed to load news!',
      updateSuccess: 'Updated successfully!',
      createSuccess: 'Added successfully!',
      submitError: 'Something went wrong!',
      deleteConfirm: 'Are you sure you want to delete?',
      deleteSuccess: 'Deleted successfully!',
      deleteError: 'Failed to delete!'
    }
  }
};


